import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const ContainerStyled = styled(Box)({
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
});
